import React from "react";
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

function UnSaveChangesPopup({
    setUnsavedChangesPopup,
    pendingData,
    handleRestoreAnswers,
    handleIgnoreAnswers,
    unsavedChangesPopup
}) {
    return (
        <Dialog
            open={unsavedChangesPopup}
            // onClose={() => setUnsavedChangesPopup(false)}
            container={document.body}
            sx={{ zIndex: 2000 }}
        >
            <DialogTitle>Unsaved Changes Found</DialogTitle>
            <DialogContent>
                <Typography>
                    You already have an unsaved homework –{" "}
                    <Typography component="span" fontWeight="bold" color="primary">
                        {pendingData?.name}
                    </Typography>
                    . Do you want to restore?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => setUnsavedChangesPopup(false)}
                    color="error"
                    variant="outlined"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleRestoreAnswers}
                    color="primary"
                    variant="outlined"
                >
                    Continue
                </Button>
                <Button
                    onClick={handleIgnoreAnswers}
                    color="primary" variant="contained">
                    Ignore
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default UnSaveChangesPopup;
